var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"typeform-container"},[(_vm.typeFormId)?_c('div',{attrs:{"data-tf-live":_vm.typeFormId}}):_c('div',{staticClass:"loading-state"},[_c('p',[_vm._v("...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }